__turbopack_context__.v({
  "arrow": "style-module-scss-module__oLKQha__arrow",
  "blur-image": "style-module-scss-module__oLKQha__blur-image",
  "carousel-item": "style-module-scss-module__oLKQha__carousel-item",
  "component": "style-module-scss-module__oLKQha__component",
  "cta": "style-module-scss-module__oLKQha__cta",
  "full": "style-module-scss-module__oLKQha__full",
  "full-height": "style-module-scss-module__oLKQha__full-height",
  "header": "style-module-scss-module__oLKQha__header",
  "map": "style-module-scss-module__oLKQha__map",
  "margin": "style-module-scss-module__oLKQha__margin",
  "no-image": "style-module-scss-module__oLKQha__no-image",
  "sign-in-overlay": "style-module-scss-module__oLKQha__sign-in-overlay",
  "slider": "style-module-scss-module__oLKQha__slider",
});
